import React, { FC } from 'react';
import { makeStyles, Theme, Box, Container, Grid, Typography } from '@material-ui/core';
import { bgImageProudMembers } from 'images/about-us';

interface ProudMembersSectionProps {
  title: string;
  text: string;
  secondText: string;
  orangeText: string;
  startText?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(15),
    backgroundImage: `url(${bgImageProudMembers})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    paddingTop: theme.spacing(20),
    paddingBottom: theme.spacing(20),
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  text: {
    marginBottom: theme.spacing(4),
  },
  orangeText: {
    color: theme.palette.primary.main,
  },
  divider: {
    width: 100,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(6),
  },
}));

const ProudMembersSection: FC<ProudMembersSectionProps> = ({ title, startText, text, secondText, orangeText }) => {
  const classes = useStyles();
  return (
    <Container fixed className={classes.root} id={'proud-members'}>
      <Grid container spacing={3}>
        <Grid item lg={1} />
        <Grid sm={12} lg={4} item data-aos="fade-right" data-aos-delay="300">
          <Typography variant="h2" className={classes.title}>
            {title}
          </Typography>
          <Box className={classes.divider} />
        </Grid>
        <Grid item lg={1} />
        <Grid sm={12} lg={6} item>
          <Typography variant="body1" className={classes.text} data-aos="fade-up" data-aos-delay="400">
            {startText}
            <span className={classes.orangeText}>{orangeText}</span>
            {text}
          </Typography>
          <Typography variant="body1" className={classes.text} data-aos="fade-up" data-aos-delay="700">
            {secondText}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProudMembersSection;
